var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52539 16C1.12539 16 0.77539 15.8458 0.47539 15.5375C0.17539 15.2292 0.0253906 14.8833 0.0253906 14.5V1.5C0.0253906 1.11667 0.17539 0.770833 0.47539 0.4625C0.77539 0.154167 1.12539 0 1.52539 0H8.52539L10.0254 1.5H18.5254C18.9087 1.5 19.2546 1.65417 19.5629 1.9625C19.8712 2.27083 20.0254 2.61667 20.0254 3V14.5C20.0254 14.8833 19.8712 15.2292 19.5629 15.5375C19.2546 15.8458 18.9087 16 18.5254 16H1.52539ZM1.52539 1.5V14.5H18.5254V3H9.40039L7.90039 1.5H1.52539ZM1.52539 1.5V14.5V1.5Z",
    fill: "#C9AF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderYellowIcon);
export default __webpack_public_path__ + "static/media/folder-yellow-icon.3def2bbd632f400e9b4412577e37690c.svg";
export { ForwardRef as ReactComponent };